export default "__VITE_ASSET__BNqeo46P__"